<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { ULTIMA, foto } from '@/lib/novidades'

// Janela de Novidades: um destaque por vez (foto com círculos + uma linha por círculo).
const emit = defineEmits(['close'])
const marca = '/brand/gestao-marca-azul.svg' // em public/: string, não import do Vite
const i = ref(0)
const item = computed(() => ULTIMA.items[i.value])
const last = computed(() => i.value === ULTIMA.items.length - 1)
const next = () => (last.value ? emit('close') : i.value++)

const onKeydown = e => {
  if (e.key === 'Escape') emit('close')
  if (e.key === 'ArrowRight') next()
  if (e.key === 'ArrowLeft' && i.value) i.value--
}
onMounted(() => window.addEventListener('keydown', onKeydown))
onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown))
</script>

<template>
  <div class="fixed inset-0 z-[95] flex items-center justify-center bg-[#152745]/45 p-4 backdrop-blur-[2px] sm:p-6">
    <section
      role="dialog"
      aria-modal="true"
      aria-labelledby="news-title"
      class="flex h-[min(760px,calc(100vh-32px))] w-full max-w-[1120px] flex-col overflow-hidden rounded-2xl bg-white shadow-[0_30px_80px_rgba(21,39,69,0.35)]"
    >
      <header class="flex items-center gap-3 border-b border-[#eef1ec] px-5 py-4">
        <img :src="marca" alt="" class="h-7 w-auto" />
        <h2 class="text-base font-extrabold text-[#152745]">Novidades do Gestão</h2>
        <span class="rounded-full border border-[#d7e6c4] bg-[#f2f8ea] px-2 text-[11px] font-bold text-[#4f7d26]">{{ ULTIMA.version }}</span>
        <button type="button" class="ml-auto grid size-8 place-items-center rounded-lg border border-[#e3e8df] text-[#777] hover:bg-[#f4f6f2]" aria-label="Fechar" @click="emit('close')">✕</button>
      </header>

      <!-- Altura fixa: cada foto tem um tamanho, e a janela não pode mudar (tremia ao passar). -->
      <div class="grid min-h-0 flex-1 md:grid-cols-[1fr_280px]">
        <div class="flex min-h-0 items-center justify-center overflow-hidden bg-[#f5f6f4] p-3">
          <img :key="item.img" :src="foto(ULTIMA.version, item.img)" alt="" class="max-h-full max-w-full object-contain rounded-lg border border-[#e2e2e2] shadow-[0_6px_20px_rgba(0,0,0,0.12)]" />
        </div>
        <div class="flex flex-col overflow-y-auto border-t border-[#eef1ec] p-5 md:border-l md:border-t-0">
          <span class="text-[11px] font-bold tracking-[0.08em] text-[#9aa69e]">{{ i + 1 }} DE {{ ULTIMA.items.length }}</span>
          <h3 id="news-title" class="mt-1.5 text-[19px] font-bold leading-tight tracking-[-0.01em] text-[#152745]">{{ item.title }}</h3>
          <p class="mt-2 text-[13.5px] text-[#4b5852]">{{ item.lead }}</p>
          <ol class="mt-4 grid gap-2.5">
            <li v-for="(pin, n) in item.pins" :key="n" class="grid grid-cols-[22px_1fr] items-start gap-2.5 text-[13px] text-[#33403a]">
              <span class="grid size-[22px] place-items-center rounded-full bg-[#f97316] text-xs font-extrabold text-white shadow-[0_2px_5px_rgba(0,0,0,0.2)]">{{ n + 1 }}</span>
              <span>{{ pin }}</span>
            </li>
          </ol>
        </div>
      </div>

      <footer class="flex items-center gap-2.5 border-t border-[#eef1ec] px-5 py-3">
        <div class="flex gap-1.5">
          <button
            v-for="(_, k) in ULTIMA.items"
            :key="k"
            type="button"
            :aria-label="`Novidade ${k + 1}`"
            class="h-[7px] rounded-full transition-all"
            :class="k === i ? 'w-5 bg-[#152745]' : 'w-[7px] bg-[#d9ded6]'"
            @click="i = k"
          />
        </div>
        <span class="flex-1" />
        <button v-if="i" type="button" class="rounded-lg border border-[#e3e8df] px-4 py-2 text-sm font-bold text-[#4b5852]" @click="i--">Voltar</button>
        <button type="button" class="rounded-lg bg-[#152745] px-4 py-2 text-sm font-bold text-white" @click="next">{{ last ? 'Entendi' : 'Próxima' }}</button>
      </footer>
    </section>
  </div>
</template>
